<template>
  <!-- 订单明细 -->
  <div>
    <div class="container" style="box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 10px">
      <e-search
        :count="searchData.count"
        :data="searchData.data"
        :field-list="searchData.fieldList"
        :list-type-info="searchData.listTypeInfo"
        :btn-style="searchData.btnStyle"
        @handleFocus="handleFocus"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      />
    </div>

    <div class="container">
      <div class="handle-wrapper">
        <eui-btn v-debounce="exportDetail" type="secondary" style="margin-right: 10px">导出订单明细</eui-btn>
        <el-tooltip class="item" effect="dark" content="根据筛选条件导出信息" placement="top">
          <span class="right-icon">?</span>
        </el-tooltip>
      </div>

      <tableList
        ref="tableRef"
        :loading="false"
        row-key="vocabularyId"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template #purchaseCompany="slot">
          <e-tooltip :content="slot.scope.row.purchaseCompany" :set-length="14" />
        </template>
        <template #supplierCompany="slot">
          <e-tooltip :content="slot.scope.row.supplierCompany" :set-length="14" />
        </template>
        <template #receiveAddress="slot">
          <e-tooltip :content="slot.scope.row.receiveAddress" :set-length="16" />
        </template>
        <template #productName="slot">
          <e-tooltip :content="slot.scope.row.productName" :set-length="26" />
        </template>
        <template #displaySkuOptions="slot">
          <e-tooltip :content="slot.scope.row.displaySkuOptions" :set-length="26" />
        </template>
        <template #zoneLabelDesc="slot">
          <e-tooltip :content="slot.scope.row.zoneLabelDesc" :set-length="20" />
        </template>
        <template #skuLabelDesc="slot">
          <e-tooltip :content="slot.scope.row.skuLabelDesc" :set-length="20" />
        </template>
          <template #tagTextIdDesc="slot">
              <eui-tooltip-over
                      :line="2"
                      :content="slot.scope.row.tagTextIdDesc"
                      :tooltipStyle="{ width: '160px', fontsize: '12px' }"
              >
                  <div>{{ slot.scope.row.tagTextIdDesc }}</div>
              </eui-tooltip-over>
          </template>
          <template #categoryName="slot">
              <eui-tooltip-over
                      :line="2"
                      :content="slot.scope.row.categoryName"
                      :tooltipStyle="{ width: '160px', fontsize: '12px' }"
              >
                  <div>{{ slot.scope.row.categoryName }}</div>
              </eui-tooltip-over>
          </template>
      </tableList>

      <div class="pagination flex-end">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <div class="margin-l20">
          交易金额：
          <span style="color: #ef4c56">{{ totalAmount }}</span>
          元
        </div>
      </div>
    </div>
    <!--采购商 和 供应商  的 弹框-->
    <query-name-dialog
      v-if="chooseVisible"
      :choose-visible="chooseVisible"
      :company-id-list="companyIdList"
      :purchase-company-info="purchaseCompanyInfo"
      :purchase-company-id-list="queryData.purchaseCompanyIdList"
      :supplier-company-info="supplierCompanyInfo"
      :supplier-company-id-list="queryData.supplierCompanyIdList"
      :select-name-flag="selectNameFlag"
      @closeDialog="closeDialog"
      @handleQueryCompany="handleQueryCompany"
    />
    <!--采购商的弹框-->
    <query-purchase-company-dialog
            v-if="queryPurchaseCompanyVisible"
            :queryPurchaseCompanyVisible.sync="queryPurchaseCompanyVisible"
            :purchaseCompanyInfo="purchaseCompanyInfo"
            @confirmPurchaseCompany="confirmPurchaseCompany"
    />
  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import tableList from '@/modules/projectA/components/common/e-table-list';
import api from '@/modules/projectA/api/order';
import productApi from '@/modules/projectA/api/product';
import eTooltip from '@/modules/projectA/components/common/e-tooltip';
import utils, { formatDate, fileExportResponseError } from '@/modules/projectA/utils/utils';
import queryNameDialog from './common/queryNameDialog';
import queryPurchaseCompanyDialog from './common/queryPurchaseCompanyDialog';

export default {
  name: 'OrderDetail',
  components: {
    eSearch,
    tableList,
    eTooltip,
    queryNameDialog,
    queryPurchaseCompanyDialog
  },
  data() {
    return {
      totalAmount: 0,
      queryData: {
        purchaseCompanyIdList: null,
        orderNo: null,
        orderStatusList: null,
        memberRealName: null,
        supplierCompanyIdList: null,
        productSkuCode: null,
        startTime: null,
        endTime: null,
        submitTime: null,
        systemSource: null,
        invoiceNode: null,
        isDoc: null,
        payment: null,
        invoiceMode: null,
        orderSourceList: null,
        electronicInvoiceFlag: null,
        startAmount: null,
        endAmount: null,
        zoneLabel: null,
        skuLabel: null,
        lbbm: null,
        tagTextId: null,
        purchaseCompanySource: null,
        collectivePriceType: null,
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      chooseVisible: false, // 采购商和供应商选择的弹框
      selectNameFlag: '', // 区别 是 采购商 还是 供应商的 字段
      companyIdList: [], // 采购商 或者 供应商默认选中得id集合
      purchaseCompanyInfo: [], // 采购商默认选中 的所有信息
      supplierCompanyInfo: [], // 供应商默认选中 的所有信息
      queryPurchaseCompanyVisible: false,//采购商选择得弹框
      searchData: {
        count: 6,
        data: {
          purchaseCompanyIdList: null,
          orderNo: null,
          orderStatusList: null,
          memberRealName: null,
          supplierCompanyIdList: null,
          productSkuCode: null,
          startTime: null,
          endTime: null,
          submitTime: null,
          systemSource: null,
          invoiceNode: null,
          isDoc: null,
          payment: null,
          invoiceMode: null,
          orderSourceList: null,
          electronicInvoiceFlag: null,
          startAmount: null,
          endAmount: null,
          zoneLabel: null,
          skuLabel: null,
          lbbm: null,
          tagTextId: null,
          purchaseCompanySource: null,
          collectivePriceType: null,
        },
        fieldList: [
          {
            label: '采购商',
            type: 'dialog',
            value: 'purchaseCompanyIdList',
            placeholder: '请输入采购商',
          },
          {
            label: '订单编号',
            type: 'input',
            value: 'orderNo',
            placeholder: '请输入订单编号',
          },
          {
            label: '商品编号',
            type: 'input',
            value: 'productSkuCode',
            placeholder: '请输入商品编号',
          },
          {
            label: '订单状态',
            type: 'select',
            multiple: 'multiple',
            value: 'orderStatusList',
            collapseTags: true,
            list: 'statusList',
            placeholder: '请选择订单状态',
          },
          {
            label: '供应商',
            type: 'dialog',
            value: 'supplierCompanyIdList',
            placeholder: '请输入供应商',
          },
          {
            label: '下单时间',
            type: 'date',
            value: 'submitTime',
            dateType: 'datetimerange',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            defaultTime: ['00:00:00', '23:59:59'],
            placeholder: '请输入下单时间',
          },
          {
            label: '商品类别编码',
            type: 'input',
            value: 'lbbm',
            placeholder: '请输入商品类别编码',
          },
          {
            label: '下单人',
            type: 'input',
            value: 'memberRealName',
            placeholder: '请输入下单人',
          },
          {
            label: '商品标识',
            type: 'select',
            value: 'skuLabel',
            list: 'skuLabelList',
            placeholder: '请选择商品标识',
          },
          {
            label: '商品标签',
            type: 'select',
            value: 'tagTextId',
            list: 'tagTextIdList',
            placeholder: '请输入商品标签',
          },
          /* {
            label: '业务来源',
            type: 'select',
            value: 'systemSource',
            list: 'businessSourceList',
            placeholder: '请选择业务来源',
          }, */
          {
            label: '专区标识',
            type: 'select',
            value: 'zoneLabel',
            collapseTags: true,
            list: 'zoneLabelList',
            placeholder: '请选择专区标识',
          },
          {
            label: '发票形式',
            type: 'select',
            value: 'electronicInvoiceFlag',
            list: 'electronicInvoiceFlagList',
            placeholder: '请选择发票形式',
          },
          {
            label: '小计金额',
            type: 'numRange',
            value1: 'startAmount',
            value2: 'endAmount',
            rangeWidth: 'min-width',
            placeholder: '请输入小计金额',
          },
          {
            label: '订单流程',
            type: 'select',
            value: 'orderSourceList',
            multiple: 'multiple',
            collapseTags: true,
            list: 'orderProcessList',
            placeholder: '请选择订单流程',
          },
          {
            label: '企业来源',
            type: 'select',
            value: 'purchaseCompanySource',
            list: 'purchaseCompanySourceList',
            placeholder: '请选择企业来源',
          },
          {
            label: '是否集采',
            type: 'select',
            value: 'collectivePriceType',
            list: 'collectivePriceTypeList',
            placeholder: '请选择是否集采',
          },
        ],
        listTypeInfo: {
          collectivePriceTypeList: [
            { name: '全部', id: null },
            { name: '非集采', id: 0 },
            { name: '集采', id: 1 },
          ],
          purchaseCompanySourceList: [
            { name: '全部', id: null },
            { name: '易派客', id: 301 },
            { name: '百望云', id: 302 },
            {name: '合金不锈专区', id: 4},
          ],
          // 订单流程
          orderProcessList: [
            { name: '商品详情页', id: 1 },
            { name: '购物车', id: 2 },
            { name: '一体化', id: 3 },
            { name: '询比价', id: 4 },
            { name: '招标订单', id: 9 },
            { name: '外部系统订单', id: 5 },
            { name: '需求计划', id: 6 },
            { name: '采购计划', id: 7 },
            { name: '清单采购下单', id: 8 },
            { name: '融合方案', id: 31 },
            {name: '标品比价', id: 21},
            {name: '合金不锈-商详页', id: 11},
            {name: '合金不锈-购物车', id: 12},
            {name: '合金不锈-询比价订单', id: 13},
          ],
          statusList: [
            { name: '待供应商确认', id: 17 },
            { name: '待采购商确认', id: 18 },
            { name: '待审批', id: 12 },
            { name: '待付款', id: 21 }, // 传[21,22,103]
            { name: '待发货', id: 31 }, // 传[31,32]
            { name: '待收货', id: 4 },
            { name: '交易完成', id: 6 },
            { name: '已取消', id: 7 },
            { name: '取消中', id: 71 },
            { name: '变更中', id: 72 },
            { name: '待付尾款', id: 102 },
            { name: '溢装待付款', id: 103 },
          ],
          /* // 业务来源
          businessSourceList: [
            { name: '全部', id: null },
            { name: '易派客2.0', id: 2 },
            { name: 'MRO', id: 3 },
            { name: '合金不锈', id: 4 },
          ], */
          // 商品标识
          skuLabelList: [
            { name: '全部', id: null },
            { name: '易资源', id: 1 },
            { name: '易专采', id: 2 },
            { name: '品牌销售商城', id: 3 },
            { name: '协议', id: 4 },
            { name: '易应急', id: 5 },
          ],

          electronicInvoiceFlagList: [
            { name: '全部', id: null },
            { name: '电子发票', id: 1 },
            { name: '纸质发票', id: 0 },
          ],
          zoneLabelList: [], // 专区标识
          tagTextIdList: [], // 商品标签
        },
      },
      tableData: [],
      tableLabel: [
        {
          label: '订单编号',
          param: 'orderNo',
          align: 'center',
          width: '160px',
          fixed: 'left',
        },
        {
          label: '商品编号',
          param: 'productSkuCode',
          align: 'center',
          width: '160px',
        },
        {
          label: '商品名称',
          param: 'productName',
          slot: 'productName',
          align: 'center',
          width: '160px',
        },
        {
          label: '规格描述',
          param: 'displaySkuOptions',
          slot: 'displaySkuOptions',
          align: 'center',
          width: '160px',
        },
        {
          label: '订单状态',
          param: 'orderStatusDesc',
          width: '120px',
          align: 'center',
        },
        {
          label: '商品标识',
          param: 'skuLabelDesc',
          slot: 'skuLabelDesc',
          align: 'center',
          width: '160px',
        },
        {
          label: '商品标签',
          param: 'tagTextIdDesc',
          align: 'center',
          width: '180px',
          slot: 'tagTextIdDesc'
        },
        {
          label: '商品类别',
          param: 'categoryName',
          align: 'center',
          width: '180px',
          slot: 'categoryName'
        },
        {
          label: '专区标识',
          param: 'zoneLabelDesc',
          slot: 'zoneLabelDesc',
          align: 'center',
          width: '160px',
        },
        {
          label: '商品类别编码',
          param: 'lbbm',
          align: 'center',
          width: '160px',
        },
        {
          label: '商品类别描述',
          param: 'lbmc',
          align: 'center',
          width: '160px',
        },

        {
          label: '数量',
          param: 'quantity',
          align: 'center',
        },
        {
          label: '计量单位',
          param: 'baseUnitName',
          align: 'center',
        },
        {
          label: '单价（元）',
          param: 'price',
          align: 'center',
          width: '110px',
        },
        {
          label: '运费（元）',
          param: 'shippingCost',
          align: 'center',
          width: '110px',
        },
        {
          label: '小计（元）',
          param: 'subtotal',
          align: 'center',
          width: '110px',
        },
        {
          label: '采购商',
          param: 'purchaseCompany',
          // slot: 'purchaseCompany',
          width: '300px',
          align: 'center',
        },
        {
          label: '下单部门',
          param: 'orgShortName',
          align: 'center',
          width: '110px',
        },
        {
          label: '下单人',
          param: 'memberRealName',
          align: 'center',
          width: '120px',
        },
        {
          label: '下单人账号',
          param: 'memberName',
          align: 'center',
          width: '120px',
        },
        {
          label: '供应商',
          param: 'supplierCompany',
          // slot: 'supplierCompany',
          width: '300px',
          align: 'center',
        },
        // {
        //   label: '供应商联系人',
        //   param: '',
        //   align: 'center',
        // },
        // {
        //   label: '供应商联系方式',
        //   param: '',
        //   align: 'center',
        // },
        {
          label: '结算类型',
          param: 'settleTypeDesc',
          align: 'center',
        },
        {
          label: '付款方式',
          param: 'paymentDesc',
          align: 'center',
        },
        {
          label: '开票节点',
          param: 'invoiceNodeDesc',
          width: '130px',
          align: 'center',
        },
        {
          label: '开票方式',
          param: 'invoiceModeCodeDesc',
          align: 'center',
        },
        {
          label: '发票形式',
          param: 'electronicInvoiceFlag',
          align: 'center',
          render: (item) => {
            let str = '';
            if (parseInt(item.electronicInvoiceFlag, 10) === 1) {
              str = '电子发票';
            } else {
              str = '纸质发票';
            }
            return str;
          },
        },
        {
          label: '配送方式',
          param: 'shipmentTypeDesc',
          align: 'center',
          width: '100px',
        },

        /* {
          label: '终端标识',
          param: 'terminalDesc',
          align: 'center',
          width: '110px',
        }, */
        /* {
          label: '业务来源',
          param: 'systemSourceDesc',
          width: '110px',
          align: 'center',
        }, */
        {
          label: '订单流程',
          param: 'businessFlow',
          width: '100px',
          align: 'center',
        },
        /* {
          label: '集成标识',
          param: 'integrated',
          width: '110px',
          align: 'center',
        }, */
        {
          label: '溢装标识',
          param: 'hasOverShipmentDesc',
          align: 'center',
        },
        {
          label: '收货人',
          param: 'receiveName',
          align: 'center',
          width: '110px',
        },
        {
          label: '联系方式',
          param: 'receivePhone',
          width: '110px',
          align: 'center',
        },
        {
          label: '收货地址',
          param: 'receiveAddress',
          slot: 'receiveAddress',
          width: '130px',
          align: 'center',
        },
      ],
    };
  },
  // 适配易派客看板跳转
  destroyed() {
    localStorage.removeItem('epecKanBanParams');
  },
  mounted() {
    this.queryOrderSkuList();
    this.queryZoneLabelList(); // 专区名称 数据字典下拉框
    this.queryTagLabelList(); // 商品标签
  },
  methods: {
    confirmPurchaseCompany(val) {
      let companyNameList = val.map((item) => item.companyName).toString();
      if (companyNameList && companyNameList.length > 15) {
        companyNameList = `${companyNameList.substring(0, 14)}...`;
      }
      this.companyIdList = val.map((item) => item.companyId);
      if (companyNameList.length > 0) {
        this.searchData.data.purchaseCompanyIdList = companyNameList;
        this.queryData.purchaseCompanyIdList = this.companyIdList;
        this.purchaseCompanyInfo = val;
      } else {
        this.searchData.data.purchaseCompanyIdList = null;
        this.queryData.purchaseCompanyIdList = null;
        this.purchaseCompanyInfo = [];
      }

    },
    // 导出订单明细
    async exportDetail() {
      const time = formatDate(new Date(), 'yyyyMMdd');
      const res = await api.exportOrderSkuList(this.queryData);
      if (res.type === 'application/json') {
        fileExportResponseError(res);
      } else {
        utils.downFile(res, `订单明细信息_${time}`, '.xls');
      }
    },
    // 采购商 和 供应商 的 多选
    handleQueryCompany(val) {
      let companyNameList = val.map((item) => item.companyName).toString();
      if (companyNameList && companyNameList.length > 15) {
        companyNameList = `${companyNameList.substring(0, 14)}...`;
      }
      this.companyIdList = val.map((item) => item.companyId);
      if (this.companyIdList.length > 0) {
        if (this.selectNameFlag === 'purchaseCompanyIdList') {
          this.searchData.data.purchaseCompanyIdList = companyNameList;
          this.queryData.purchaseCompanyIdList = this.companyIdList;
          this.purchaseCompanyInfo = val;
        } else if (this.selectNameFlag === 'supplierCompanyIdList') {
          this.searchData.data.supplierCompanyIdList = companyNameList;
          this.queryData.supplierCompanyIdList = this.companyIdList;
          this.supplierCompanyInfo = val;
        }
      } else if (this.selectNameFlag === 'purchaseCompanyIdList') {
        this.searchData.data.purchaseCompanyIdList = null;
        this.queryData.purchaseCompanyIdList = null;
        this.purchaseCompanyInfo = [];
      } else if (this.selectNameFlag === 'supplierCompanyIdList') {
        this.searchData.data.supplierCompanyIdList = null;
        this.queryData.supplierCompanyIdList = null;
        this.supplierCompanyInfo = [];
      }
      this.chooseVisible = false;
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryData.pageNum = 1;
      this.queryOrderSkuList();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.queryOrderSkuList();
    },
    // 统一关闭弹框
    closeDialog() {
      this.chooseVisible = false;
    },
    handleFocus(obj) {
      this.selectNameFlag = obj.item;
      if (this.selectNameFlag === 'purchaseCompanyIdList') {
        this.queryPurchaseCompanyVisible = true;
      } else {
        this.chooseVisible = true;
      }
    },
    handleFilter(val) {
      let orderStatusList = val.orderStatusList && val.orderStatusList.length > 0 ? val.orderStatusList : [];
      if (val.orderStatusList) {
        if (orderStatusList.includes(21)) {
          const arr = [22, 23];
          orderStatusList = val.orderStatusList.concat(arr);
        }
        if (orderStatusList.includes(31)) {
          orderStatusList.push(32);
        }
      }

      // 线下支付方式
      const underLine = [101, 102, 103, 104, 105];
      // 线上支付方式
      const online = [0, 1, 2, 3, 4];

      // isOnlinePay 在线支付 0 否 1 是
      if (underLine.includes(val.payment)) {
        this.queryData.isOnlinePay = 0;
      } else if (online.includes(val.payment)) {
        this.queryData.isOnlinePay = 1;
      } else {
        this.queryData.isOnlinePay = null;
      }

      this.queryData.orderNo = val.orderNo;
      this.queryData.orderStatusList = orderStatusList.length > 0 ? orderStatusList : null;
      this.queryData.memberRealName = val.memberRealName;
      this.queryData.startTime = val.submitTime ? val.submitTime[0] : null;
      this.queryData.endTime = val.submitTime ? val.submitTime[1] : null;
      this.queryData.systemSource = val.systemSource;
      this.queryData.invoiceNode = val.invoiceNode;
      this.queryData.isDoc = val.isDoc;
      this.queryData.payment = val.payment;
      this.queryData.invoiceMode = val.invoiceMode;
      this.queryData.orderSourceList = val.orderSourceList;
      this.queryData.electronicInvoiceFlag = val.electronicInvoiceFlag;
      this.queryData.startAmount = val.startAmount;
      this.queryData.endAmount = val.endAmount;
      this.queryData.skuLabel = val.skuLabel;
      this.queryData.zoneLabel = val.zoneLabel;
      this.queryData.lbbm = val.lbbm;
      this.queryData.productSkuCode = val.productSkuCode;
      this.queryData.tagTextId = val.tagTextId;
      this.queryData.purchaseCompanySource = val.purchaseCompanySource;
      this.queryData.collectivePriceType = val.collectivePriceType;
      this.queryData.pageNum = 1;

      this.queryOrderSkuList();
    },
    handleReset() {
      this.searchData.data.purchaseCompanyIdList = '';
      this.searchData.data.supplierCompanyIdList = '';
      this.companyIdList = [];
      this.purchaseCompanyInfo = [];
      this.supplierCompanyInfo = [];

      this.queryData = {
        electronicInvoiceFlag: null,
        purchaseCompanyIdList: null,
        orderNo: null,
        orderStatusList: null,
        memberRealName: null,
        supplierCompanyIdList: null,
        startTime: null,
        endTime: null,
        submitTime: null,
        systemSource: null,
        invoiceNode: null,
        isDoc: null,
        payment: null,
        invoiceMode: null,
        orderSourceList: null,
        isOnlinePay: null,
        startAmount: null,
        endAmount: null,
        lbbm: null,
        productSkuCode: null,
        tagTextId: null,
        purchaseCompanySource: null,
        collectivePriceType: null,
        pageSize: 10,
      };
      this.queryOrderSkuList();
    },
    async queryOrderSkuList() {
      // 适配 易派客看板代码
      const epecKanBanParams = JSON.parse(localStorage.getItem('epecKanBanParams')) || {};
      if (Object.keys(epecKanBanParams).length > 0) {
        this.searchData.fieldList[0].disabled = true;
        const { companyId } = epecKanBanParams;
        this.queryData.purchaseCompanyIdList = [companyId];
      }

      const res = await api.orderQueryOrderSkuList(this.queryData);
      if (res.code === '200') {
        this.tableData = res.data.records;
        this.pageTotal = res.data.total;
        // 订单金额小计
        this.queryOrderSkuTotalAmount();
      }
    },
    async queryOrderSkuTotalAmount() {
      const res = await api.queryOrderSkuTotalAmount(this.queryData);
      if (res.code === '200') {
        this.totalAmount = res.data || 0;
      }
    },
    async queryZoneLabelList() {
      const res = await productApi.queryZoneLabelList();
      if (res.success) {
        res.data.forEach((item) => {
          this.searchData.listTypeInfo.zoneLabelList.push({
            name: item.tagTextForZoneName,
            id: item.tagTextForZoneId,
          });
        });
      }
    },
    async queryTagLabelList() {
      const res = await productApi.queryTagLabelList();
      if (res.success) {
        res.data.forEach((item) => {
          this.searchData.listTypeInfo.tagTextIdList.push({
            name: item.tagTextLabel,
            id: item.tagTextLabelId,
          });
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* .empty-mark {
  margin-left: 6px;
  background: url('@/assets/img/common/query-empty-mark.png') no-repeat;
  background-size: 18px 18px;
  width: 18px;
  height: 18px;
  cursor: pointer;

  &:hover {
    background-image: url('@/assets/img/common/real-mark.png');
  }
} */
.flex-end {
  display: flex;
  justify-content: end;
  align-items: center;
}
.right-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-left: 4px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  font-size: 12px;
  color: #c5c5c5;
  cursor: pointer;
  &:hover {
    background: #c5c5c5;
    color: #fff;
  }
}
</style>
